import React from 'react';
import styled from 'styled-components';
import IDHelpers from '../../../../core/helpers/IDHelper';
import constants from '../../../../core/constants';
import CardCourse from './CardCourse';
import ClockLine from './ClockLine';
import Block from '../../Block';

const ScheduleGridBody = styled.div.attrs((props: any) => ({
  percent: props.percent,
  isLast: props.isLast,
  isToday: props.isToday
}))`
  width: ${(props) => props.percent}%;
  position: relative;
  background-color: #fff;
  height: 100%;

  @media (min-width: ${constants.BREAKPOINT_SIZE}px) {
    background-color: ${(props) => (props.isToday ? '#fff' : '#f7fbfd')};
  }
`;

const HourBlock = styled.div.attrs((props: any) => ({
  isFisrt: props.isFisrt,
  isToday: props.isToday
}))`
  height: 100px;
  border-top-width: ${(props) => (props.isFisrt ? '0' : '1')}px;
  // border-top-width: 1px;
  border-left-width: 1px;
  border-color: var(--background-background-disabled);
  border-style: solid;
  position: relative;
  width: 100%;
  background-color: ${(props) => (props.isToday ? '#fff' : '#f7fbfd')};
  box-shadow: ${(props) =>
    props.isToday ? '0 8px 24px -16px #c7c7c7' : 'none'};
  @media (min-width: ${constants.BREAKPOINT_SIZE}px) {
    height: 80px;
  }
`;

const HourHalfBlock = styled.div.attrs((props: any) => ({
  isFisrt: props.isFisrt
}))`
  height: 40px;
  /* border-top-width: ${(props) => (props.isFisrt ? '0' : '1')}px;*/
  border-top-width: 1px;
  border-top-color: var(--background-background-disabled);
  border-top-style: dashed;
  position: absolute;
  top: 50px;
  width: 100%;
  @media (min-width: ${constants.BREAKPOINT_SIZE}px) {
    top: 40px;
  }
`;

interface Props {
  startHour: number;
  endHour: number;
  meetings: any[];
  percent: number;
  isLast: boolean;
  isToday: boolean;
  dateEvent: any;
  handleOpenModalDetail: () => void;
  handleCloseModalDetail: () => void;
  handleContentModalDetail: (content: any) => void;
}

function DayOfSchedule(props: Readonly<Props>) {
  const {
    startHour,
    endHour,
    meetings,
    percent,
    isLast,
    isToday,
    dateEvent,
    handleOpenModalDetail,
    handleCloseModalDetail,
    handleContentModalDetail
  } = props;
  const items = [];
  for (let index = startHour; index <= endHour; index += 1) {
    items.push(
      <HourBlock
        key={IDHelpers.generateID()}
        isFisrt={index === startHour}
        isToday={isToday}
      >
        <>
          {isToday && index === startHour ? (
            <div className="clocktimer">
              <ClockLine timer={1} startHour={startHour} />
            </div>
          ) : (
            <Block />
          )}
        </>
        <HourHalfBlock />
      </HourBlock>
    );
  }

  const validateProgramming = (meeting: any) => {
    switch (meeting.type) {
      case 'C':
        return meeting?.isReprog;

      case 'A':
        return meeting?.isReprog;

      case 'P':
        return meeting?.isReprog;

      case 'R':
        return meeting?.isReprog;

      default:
        return false;
    }
  };

  return (
    <ScheduleGridBody percent={percent} isLast={isLast} isToday={isToday}>
      {items}
      <>
        {meetings &&
          meetings.map((meeting: any) => (
            <CardCourse
              id={meeting.eventId}
              key={`meet-${IDHelpers.generateID()}`}
              contentData={meeting}
              // isReprogramming={
              //   meeting?.type === 'C' ? meeting?.isReprog : false
              // }
              isReprogramming={validateProgramming(meeting)}
              cardType={meeting.type}
              dateEvent={dateEvent}
              handleOpenModalDetail={handleOpenModalDetail}
              handleCloseModalDetail={handleCloseModalDetail}
              handleContentModalDetail={handleContentModalDetail}
            />
          ))}
      </>
    </ScheduleGridBody>
  );
}

export default DayOfSchedule;
